import secondaryComponents from "../..";
import DeliveryFee from "../DeliveryFee";
import Discount from "../Discount";
import Loyalty from "../Loyalty";
import styles from "./styles.module.scss";

export const CartExtraButtonGroup = ({
  storeDetails,
  totalCalculatedPrice,
  style = {},
}) => {
  return (
    <div className={styles.cartExtraButtonGroup}>
      <Loyalty
        currency_symbol={storeDetails?.currency_symbol}
        btnStyle={style}
      />

      <secondaryComponents.NavigateWithPermission
        permissionParentKey={"Inventory Management"}
        permissionChildKey="can_apply_discount"
      >
        <Discount
          storeId={storeDetails?.id}
          currency_symbol={storeDetails?.currency_symbol}
          totalAmount={totalCalculatedPrice}
          btnStyle={style}
        />
      </secondaryComponents.NavigateWithPermission>
      <secondaryComponents.NavigateWithPermission
        permissionParentKey={"Inventory Management"}
        permissionChildKey="can_apply_delivery_fee"
      >
        <DeliveryFee
          storeId={storeDetails?.id}
          currency_symbol={storeDetails?.currency_symbol}
          btnStyle={style}
        />
      </secondaryComponents.NavigateWithPermission>
    </div>
  );
};
